<div class="mapper-test-run-artifact-list" *ngIf="items.length">
	<div class="mapper-test-run-artifact-item" [attr.data-cy]="'mapper-test-run-artifact-' + item.sourceId" *ngFor="let item of items; trackBy: trackItem">
		<div class="mapper-test-run-artifact-head">
			<div>
				<strong>{{ item.summary }}</strong>
				<span>{{ item.actionLabel }}</span>
			</div>
			<div class="mapper-test-run-artifact-actions">
				<button type="button" class="mapper-artifact-toggle-btn" data-cy="mapper-toggle-unmapped-artifact-fields-button" (click)="toggleUnmappedFields.emit()">
					{{ showUnmappedFields ? 'Hide unmapped fields' : 'Show unmapped fields' }}
				</button>
				<span class="state-pill" [attr.data-tone]="item.statusTone">{{ item.statusLabel }}</span>
			</div>
		</div>

		<div class="mapper-test-run-artifact-error" [attr.data-cy]="'mapper-test-run-artifact-error-' + item.sourceId" *ngIf="item.errorMessage">
			{{ item.errorMessage }}
		</div>

		<div class="mapper-test-run-artifact-grid mapper-artifact-trace-grid" [class.has-active-trace]="activeArtifactTraceId" (mouseleave)="setActiveArtifactTrace(null)">
			<div class="mapper-test-run-artifact-panel mapper-artifact-trace-panel" [attr.data-cy]="'mapper-test-run-artifact-' + item.sourceId + '-' + panel.stage + '-panel'" *ngFor="let panel of item.panels; trackBy: trackPanel">
				<div class="mapper-test-run-artifact-panel-title mapper-artifact-trace-panel-title">
					<span>{{ panel.title }}</span>
					<small>{{ panel.subtitle }}</small>
				</div>

				<div class="mapper-artifact-trace-empty" *ngIf="!panel.rows.length">{{ panel.emptyText }}</div>
				<div class="mapper-artifact-trace-empty" *ngIf="panel.rows.length && !showUnmappedFields && !panel.mappedRows.length">Unmapped fields are hidden for this phase.</div>

				<div class="mapper-artifact-trace-row"
					*ngFor="let row of (showUnmappedFields ? panel.rows : panel.mappedRows); trackBy: trackRow"
					data-cy="mapper-test-run-artifact-row"
					[attr.data-artifact-stage]="row.stage"
					[attr.data-artifact-path]="row.path"
					[class.is-active]="row.traceId && row.traceId === activeArtifactTraceId"
					[class.is-dimmed]="activeArtifactTraceId && row.traceId !== activeArtifactTraceId"
					[class.is-source-mapped]="row.stage === 'source' && row.traceId"
					[class.is-source-unmapped]="row.stage === 'source' && !row.traceId"
					[attr.data-tone]="row.tone"
					[attr.title]="row.description"
					[attr.tabindex]="row.traceId ? 0 : -1"
					(mouseenter)="setActiveArtifactTrace(row.traceId)"
					(focus)="setActiveArtifactTrace(row.traceId)"
					(blur)="setActiveArtifactTrace(null)">
					<div class="mapper-artifact-trace-path">
						<strong>{{ row.label }}</strong>
						<span class="mapper-artifact-trace-path-meta">
							<span>{{ row.path }}</span>
							<small *ngIf="row.stage === 'source' && row.traceId">Mapped</small>
						</span>
					</div>
					<div class="mapper-artifact-trace-value">{{ row.value }}</div>
				</div>
			</div>
		</div>
	</div>
</div>
